export const PUBLIC_DOC_COMPONENT_URL = 'https://public-ui.github.io/docs/components';
export const PUBLIC_CODE_COMPONENT_URL = 'https://github.com/public-ui/kolibri/blob/develop/packages/samples/react/src/components';
export const ERROR_MSG = 'I am an error message!';
export const HINT_MSG = 'I am a hint.';
